import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as actions from '../../../store/actions'
import Gallery from '../../../components/gallery'
import Pagination from '../../../components/pagination'
import ArtistHeader from '../../../components/headers/artist'
import Loading from '../../../components/loading'

function mapStateToProps(state) {
  return { page: state.pageSlugData[0], posts: state.posts.data, numPages: parseInt(state.posts.numPages, 10) };
}

const mapDispatchToProps = (dispatch) => {
  const { fetchPageBySlug, fetchPosts } = actions;
  return {
    fetchPageBySlug: bindActionCreators(fetchPageBySlug, dispatch),
    fetchPosts: bindActionCreators(fetchPosts, dispatch)
  }
}

class ArtistProfile extends React.Component {
  constructor() {
    super();

    this.nextPage = this.nextPage.bind(this);
    this.prevPage = this.prevPage.bind(this);

    this.state = this.resetState();
  }

  resetState() {
    return {
      pageNumber: 1,
      isLoading: true
    }
  }

  componentWillMount() {
    this.fetchPage(this.props);
  }

  fetchPage(props) {
    let _props = props || this.props;

    _props.fetchPageBySlug(_props.match.params.artistSlug, () => {
      this.fetchPosts(this.props);
    });
  }

  fetchPosts(props) {
    let _props = props || this.props;

    _props.fetchPosts({
      'categories': _props.page.acf.category_id,
      'per_page': '16',
      'page': this.state.pageNumber,
      '_embed': 'true'
    }, () => {
      this.setState({
        isLoading: false
      })
    })
  }

  nextPage() {
    this.setState({
      pageNumber: this.state.pageNumber + 1
    }, () => {
      this.fetchPosts();
    });
  }

  prevPage() {
    this.setState({
      pageNumber: this.state.pageNumber - 1
    }, () => {
      this.fetchPosts()
    });
  }

  render() {
    const { page, posts, numPages } = this.props

    if (this.state.isLoading || !page) { return <Loading /> }

    const { slug, acf, content, availability } = page
    const { profile_image, specialty } = acf
    const bio = content.rendered
    const headerProps = { slug, acf, profile_image, specialty, availability }

    let bioEl
    let PaginationEl

    if (bio && slug) {
      bioEl = <div className="artist-bio">
                  <h3>A little about { slug } ...</h3>
                  <p dangerouslySetInnerHTML={{ __html: bio }}></p>
              </div>
    }

    if (numPages > 0) {
      PaginationEl = <Pagination
                        onNext={ this.nextPage }
                        onPrev={ this.prevPage }
                        page={ this.state.pageNumber }
                        pageCount={ this.props.numPages }
                        />
    }

    return (
      <div className="artist">
        <div className="container container--grid">
          <ArtistHeader { ...headerProps } />
          <div className="row">
            { bioEl }
          </div>
          <div className="row">
            <Gallery posts={ posts } />
            { PaginationEl }
          </div>
        </div>
      </div>
    );
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.match.params.artistSlug !== nextProps.match.params.artistSlug) {
      this.setState(this.resetState());
      this.fetchPage(nextProps);
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps)(ArtistProfile);



// WEBPACK FOOTER //
// ./src/routes/team/artist-profile/index.js